import axios from 'axios';

const API_BASE_URL = 'https://api.plus2money.com/api/v1';

interface UserUpdate {
  first_name?: string;
  last_name?: string;
  email?: string;
}

interface UserResponse {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
}

interface PaymentSessionInfo {
  user_id: string;
  phone: string;
  amount: number;
  transaction_id: string;
}

interface CheckoutSessionRequest {
  user_id: string;
  recipient_phone: string;
  amount_cents: number;
}

interface CheckoutSessionResponse {
  checkout_url: string;
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const userService = {
  getUser: async (userId: string): Promise<UserResponse> => {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  updateUser: async (userId: string, userData: UserUpdate): Promise<UserResponse> => {
    const response = await api.patch(`/users/${userId}`, userData);
    return response.data;
  },

  createCheckoutSession: async (userId: string, recipientPhone: string, amountCents: number): Promise<{ checkout_url: string }> => {
    const response = await api.post('/payments/checkout-session', {
      user_id: userId,
      recipient_phone: recipientPhone,
      amount_cents: amountCents,
    });
    return response.data;
  },
};

export const paymentService = {
  getSessionInfo: async (userId: string): Promise<PaymentSessionInfo> => {
    const response = await api.get(`/payments/session-info`, {
      params: { uid: userId }
    });
    return response.data;
  },

  createCheckoutSession: async (sessionData: CheckoutSessionRequest): Promise<CheckoutSessionResponse> => {
    const response = await api.post('/payments/checkout-session', sessionData);
    return response.data;
  }
}; 